import script from "./BulmaNumberInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./BulmaNumberInput.vue?vue&type=script&setup=true&lang=ts"

import "./BulmaNumberInput.vue?vue&type=style&index=0&id=1ade7176&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ade7176"]])

export default __exports__